module.exports = __webpack_public_path__ + "img/VorsichtSieBeißt.f24f5c22.svg";